export default __webpack_public_path__ + "6c97025b70cee92e0d63bb3675348bda.svg";